import { get } from "helpers/api_helper/ApiHelpers/apiHelpers"
import * as url from "helpers/url_helper/url_helper"

export const GetAllProvisionStatusDef = () => get(url.PROVISION_STATUS_DEF_GET)